/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FaPlus, FaKey, FaInfoCircle } from 'react-icons/fa';
import './style.scoped.scss';
import { formatDate, notification, ROUTES } from '../../../assets/constants/strings';
import $ from 'jquery';
import CreateModal from './CreateModal';
import SecretModal from './SecretModal';
import Loader from '../../Loader';
import { getApiKeys, createApiKey, revokeApiKey } from '../../../services/axios';

const mapStateToProps = (state) => ({
  token: state.user.user ? state.user.user.token : null,
});

const connector = connect(mapStateToProps);

const ApiKeys = ({ token }) => {
  const [keys, setKeys] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreating, setIsCreating] = useState(false);
  const [createdKey, setCreatedKey] = useState(null);

  const fetchKeys = async () => {
    if (!token) return;
    setIsLoading(true);
    const res = await getApiKeys(token);
    setKeys(Array.isArray(res) ? res : []);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchKeys();
  }, [token]);

  const openCreate = () => $('#createKeyModal').modal('show');

  const handleCreate = async (name) => {
    if (isCreating) return;
    setIsCreating(true);
    const res = await createApiKey(token, name);
    setIsCreating(false);

    if (res.success) {
      $('#createKeyModal').modal('hide');
      setCreatedKey(res.data);
      $('#revealKeyModal').modal('show');
      fetchKeys();
    } else {
      notification(
        'info',
        'Could not create key',
        res.reason || 'Please try again.'
      );
    }
  };

  const handleRevoke = async (row) => {
    const ok = window.confirm(
      `Revoke "${row.name || 'this key'}"? Applications using it will stop working immediately.`
    );
    if (!ok) return;

    const res = await revokeApiKey(token, row.id);
    if (res.success) {
      notification('success', 'API key revoked');
      fetchKeys();
    } else {
      notification(
        'info',
        'Could not revoke key',
        res.reason || 'Please try again.'
      );
    }
  };

  const activeCount = keys.filter((k) => k.isActive).length;

  return (
    <div className='apik'>
      {/* Header — short intro + primary action (page title lives in the banner) */}
      <div className='apik-head'>
        <p className='apik-head__sub'>
          Create and manage the keys your application uses to authenticate with
          the API.
        </p>
        <button className='apik-btn apik-btn--primary' onClick={openCreate}>
          <FaPlus /> Create API key
        </button>
      </div>

      {/* Auth guidance */}
      <div className='apik-note'>
        <FaInfoCircle className='apik-note__icon' />
        <span>
          Authenticate by sending your key and secret as the{' '}
          <code>X-Api-Key</code> and <code>X-Api-Secret</code> headers. The
          secret is shown <b>only once</b>, when you create a key — store it
          securely and never expose it in client-side code. See the{' '}
          <Link to={ROUTES.APIExplorer}>API Explorer</Link> for ready-to-run
          examples.
        </span>
      </div>

      {/* Keys */}
      <div className='apik-card'>
        {!isLoading && keys.length > 0 && (
          <div className='apik-card__head'>
            <h3 className='apik-card__title'>Your keys</h3>
            <span className='apik-card__count'>
              {activeCount} active · {keys.length} total
            </span>
          </div>
        )}

        {isLoading ? (
          <div className='apik-loading'>
            <Loader />
          </div>
        ) : keys.length === 0 ? (
          <div className='apik-empty'>
            <span className='apik-empty__icon'>
              <FaKey />
            </span>
            <h3 className='apik-empty__title'>No API keys yet</h3>
            <p className='apik-empty__text'>
              Create your first key to start calling the API from your own
              application.
            </p>
            <button className='apik-btn apik-btn--primary' onClick={openCreate}>
              <FaPlus /> Create API key
            </button>
          </div>
        ) : (
          <div className='apik-tablewrap'>
            <table className='apik-table'>
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Key</th>
                  <th>Created</th>
                  <th>Status</th>
                  <th aria-label='Actions' />
                </tr>
              </thead>
              <tbody>
                {keys.map((k) => (
                  <tr key={k.id}>
                    <td className='apik-table__name'>
                      {k.name || <span className='apik-muted'>Unnamed key</span>}
                    </td>
                    <td>
                      <code className='apik-keycode'>{k.maskedKey}</code>
                    </td>
                    <td className='apik-muted'>
                      {k.created ? formatDate(k.created) : '—'}
                    </td>
                    <td>
                      <span
                        className={`apik-status ${
                          k.isActive ? 'is-active' : 'is-revoked'
                        }`}
                      >
                        {k.isActive ? 'Active' : 'Revoked'}
                      </span>
                    </td>
                    <td className='apik-table__actions'>
                      {k.isActive ? (
                        <button
                          className='apik-revoke'
                          onClick={() => handleRevoke(k)}
                        >
                          Revoke
                        </button>
                      ) : (
                        <span className='apik-muted'>—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      <CreateModal handleCreate={handleCreate} isCreating={isCreating} />
      <SecretModal createdKey={createdKey} />
    </div>
  );
};

export default connector(ApiKeys);
